import prop from 'ramda/es/prop';
import omit from 'ramda/es/omit';
import pipe from 'ramda/es/pipe';
import i18n from 'app/i18n';

import api from 'app/actions/api';
import action from 'app/common/lib/action';
import { toCamelCase } from 'app/common/lib/object';


export const PAYMENT_METHODS_REQUEST = 'PAYMENT_METHODS_REQUEST';
export const PAYMENT_METHODS_SUCCESS = 'PAYMENT_METHODS_SUCCESS';
export const PAYMENT_METHODS_FAILURE = 'PAYMENT_METHODS_FAILURE';
export const PAYMENT_METHODS_CLEAR = 'PAYMENT_METHODS_CLEAR';


/**
* Запрос методов оплаты столовой
*/
export const paymentMethodsFetch = studentId => async (dispatch) => {
  const params = studentId ? {
    student_id: studentId,
  } : {};
  dispatch(action(PAYMENT_METHODS_REQUEST, { studentId }));
  try {
    const res = await api('cabinet/payment_methods/cafeteria', 'get', { params });
    const data = pipe(
      prop('data'),
      omit(['result']),
      toCamelCase
    )(res);
    dispatch(action(PAYMENT_METHODS_SUCCESS, data));
  } catch (error) {
    dispatch(action(PAYMENT_METHODS_FAILURE, {
      err: i18n.t('app:request_payments_methods_failed'),
      error,
      studentId,
    }));
  }
};
